import React from 'react';
import { Image as ImageType } from '../../../commonTypes/image';
import { CallToAction } from '../../../commonTypes/links';
import componentProps, { ComponentProps } from '../../../helpers/componentProps';
import { applyComponentTheme } from '../../../theme';
import {
  CtaWrapper,
  Heading,
  ImageAndCtaCardContainer,
  ImageWrapper,
  StyledImage,
  StyledPrimaryCta,
  StyledRichText,
  StyledSecondaryCta,
  StyledText,
  TextWrapper,
  ThreeCardVariantHeading,
  ThreeCardVariantPrimaryCta,
  ThreeCardVariantRichText,
  ThreeCardVariantSecondaryCta,
  ThreeCardVariantText,
} from './styles';

export type ImageAndCtaCardData = {
  image: ImageType;
  heading: string;
  body: string;
  primaryCta?: CallToAction;
  secondaryCta?: CallToAction;
  useRichText?: boolean;
};

export type ImageAndCtaCardProps = {
  threeCardVariant: boolean;
} & ImageAndCtaCardData &
  ComponentProps;

export const ImageAndCtaCardContent: React.FC<ImageAndCtaCardProps> = ({
  image,
  heading,
  body,
  primaryCta,
  secondaryCta,
  threeCardVariant,
  useRichText,
}) => {
  return (
    <>
      <ImageWrapper>
        <StyledImage image={image} focusable={false} />
      </ImageWrapper>
      {threeCardVariant === true ? (
        <>
          <TextWrapper>
            <ThreeCardVariantHeading>{heading}</ThreeCardVariantHeading>
            {useRichText ? (
              <ThreeCardVariantRichText html={body}></ThreeCardVariantRichText>
            ) : (
              <ThreeCardVariantText>{body}</ThreeCardVariantText>
            )}
          </TextWrapper>
          <CtaWrapper>
            {primaryCta && <ThreeCardVariantPrimaryCta cta={primaryCta} />}
            {secondaryCta && <ThreeCardVariantSecondaryCta cta={secondaryCta} />}
          </CtaWrapper>
        </>
      ) : (
        <>
          <TextWrapper>
            <Heading>{heading}</Heading>
            {useRichText ? (
              <StyledRichText html={body}></StyledRichText>
            ) : (
              <StyledText>{body}</StyledText>
            )}
          </TextWrapper>
          <CtaWrapper>
            {primaryCta && <StyledPrimaryCta cta={primaryCta} />}
            {secondaryCta && <StyledSecondaryCta cta={secondaryCta} />}
          </CtaWrapper>
        </>
      )}
    </>
  );
};

const ImageAndCtaCard: React.FC<ImageAndCtaCardProps> = (props) => (
  <ImageAndCtaCardContainer {...componentProps(props)} tabIndex={0}>
    <ImageAndCtaCardContent {...props} />
  </ImageAndCtaCardContainer>
);

export default applyComponentTheme(ImageAndCtaCard, 'ImageAndCtaCard');
